import type { HelpFile } from '../../types/help'
import { LayoutCanvasTestIds } from '../../../testids/LayoutCanvasTestIds'

export const layoutCanvasHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [LayoutCanvasTestIds.canvasAddSectionBtn]:
      'Neuen Abschnitt zum Layout hinzufügen — Abschnitte gruppieren zusammengehörige Felder visuell.',
    [LayoutCanvasTestIds.canvasAddSectionMoreBtn]:
      'Weiteren Abschnitt unter den bestehenden hinzufügen.',
    [LayoutCanvasTestIds.canvasEmptyTitle]:
      'Das Layout ist leer — Abschnitt hinzufügen, um Felder anzuordnen.',
  },
}
